<template>
  <div class="RewardChart">
    <div id="chart"></div>
    <div class="RewardChart-footer"></div>
  </div>
</template>

<script>
  import * as CanvasJS from 'canvasjs/src/main/index';
  import { mapState } from 'vuex';

  export default {
    name: 'rewardChart',
    computed: {
      ...mapState('nodes', {
        rewardsData: 'rewards',
      }),
    },
    watch: {
      rewardsData(n) {
        const rewardsData = n;
        const dataPoints = [];
        for (let i = 0, len = rewardsData.length; i < len; i += 1) {
          const item = rewardsData[i];
          const dataPoint = {
            x: i,
            y: Number(item.amroi.toFixed(2)),
            label: item.name,
          };
          dataPoints.push(dataPoint);
        }
        const options = {
          axisY: {
            // title: 'VSYS',
            titleFontSize: 18,
            gridColor: '#FFE3D1',
            tickColor: '#FFE3D1',
            lineColor: '#FFE3D1',
          },
          axisX: {
            labelFontSize: 14,
            tickColor: '#FFE3D1',
            lineColor: '#FFE3D1',
          },
          dataPointMaxWidth: 124,
          data: [{
            color: '#FFE3D1',
            type: 'column',
            toolTipContent: '<div class="RewardChart-tooltip"><span>{label}: </span>{y}VSYS</div>',
            dataPoints,
          }],
        };
        const chart = new CanvasJS.Chart('chart', options);
        chart.render();
      },
    },
  };
</script>

<style lang="scss">
  .RewardChart {
    // margin-top: 50px;
    &-title {
      text-align: center;
      font-size: 31px;
      color: #FF8837;
      font-family: SourceHanSansSC-bold;
    }
    &-tooltip{
      padding: 5px 0;
      span{
        font-weight: bold;
      }
    }
  }

  #chart {
    margin-top: 50px;
    height: 400px;
  }
</style>
